// src/pages/shop-settings-tabs/PromotionTab.jsx
import React from 'react';
import FullReductionSettingsCard from '../../components/settings/FullReductionSettingsCard';

const PromotionTab = ({ settings, toggleField }) => (
  <div className="max-w-2xl">
    <FullReductionSettingsCard settings={settings} onToggle={toggleField} />
  </div>
);

export default PromotionTab;